import * as React from "react"
import Link from "next/link"
import { ArrowRightIcon } from "@/components/brand-kit/icon-sprite"
import { SectionHeader } from "./section-header"
import { BRAND_TOOL_CARDS } from "./types"

/**
 * "Useful Tools" 3-col card row (handoff §7).
 *
 * Each card is a horizontal hit-area: gradient orange-tinted glyph tile on
 * the left, title + sub on the right, and a trailing chevron that drifts +2px
 * on hover. Tools live at `/tools/[slug]` — currently hardcoded to the three
 * canonical calculators most relevant to a refrigerator-shopping flow.
 */
export function ToolsGrid() {
  return (
    <section className="my-12">
      <SectionHeader eyebrow="Plan ahead" title="Useful Tools" />
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {BRAND_TOOL_CARDS.map(t => (
          <Link
            key={t.href}
            href={t.href}
            prefetch={false}
            className="group flex items-center gap-3.5 rounded-[10px] border border-gray-200 bg-white px-4 py-4 transition-all duration-200 hover:-translate-y-0.5 hover:border-[#ff9951] hover:shadow-[0_6px_16px_-8px_rgba(0,0,0,0.08)]"
          >
            <div className="grid h-10 w-10 flex-shrink-0 place-items-center rounded-lg bg-[#ff9951]/10 text-[20px]">
              <span aria-hidden>{t.glyph}</span>
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-[14px] font-bold tracking-[-0.01em] text-gray-900">{t.title}</p>
              <p className="mt-0.5 text-[12px] leading-snug text-gray-500">{t.sub}</p>
            </div>
            <ArrowRightIcon
              className="h-4 w-4 flex-shrink-0 text-gray-300 transition-all duration-150 group-hover:translate-x-0.5 group-hover:text-[#ff9951]"
              aria-hidden
            />
          </Link>
        ))}
      </div>
    </section>
  )
}
